<template>
  <el-dialog
    width="70%"
    :title="$t('common.Product_accessories')"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="cancel"
    :visible.sync="dialogFormVisible"
  >
    <div class="tree1">
      <!--内容-->
      <div class="tree">
        <el-divider content-position="left">{{$t('label.Base_Information')}}</el-divider>
        <!--基本信息-->
        <el-descriptions class="margin-top" title="" :column="2" border>
            <el-descriptions-item>
                <template slot="label">{{$t('label.Order_number2')}}</template>{{orderNo}}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">{{$t('label.Customer_Name')}}</template>{{companyName}}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">{{$t('label.Trade_name')}}</template>{{spuName}}
            </el-descriptions-item>
        </el-descriptions>
        <el-divider content-position="left">{{$t('label.Accessories_Information')}}</el-divider>
        <!--已选择的配件信息-->
        <el-button type="primary" @click="openSelectAccessory()" :loading="openSelectAccessoryLoading">{{ $t('button.Add') }}<i class="el-icon-plus el-icon--right"></i></el-button>
        <el-table
            :data="selectedAccessoryData.filter(data => !search 
            || data.accessoryName.toLowerCase().includes(search.toLowerCase())
            || data.dimension.toLowerCase().includes(search.toLowerCase())
            || data.material.toLowerCase().includes(search.toLowerCase())
            || data.thread.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%">
            <el-table-column :label="$t('label.Name')" prop="accessoryName"/>     
            <el-table-column :label="$t('label.Size')" prop="dimension"/>   
            <el-table-column :label="$t('label.Material')" prop="material"/>    
            <el-table-column :label="$t('label.Screw_thread')" prop="thread"/>
            <el-table-column :label="$t('common.quantity')" prop="accessoryCount"/>  
            <el-table-column :label="$t('common.Unit_price')" prop="accessoryPrice" :formatter="formatAmount">
              <template slot-scope="scope">
                <el-input-number size="mini"  :min="0" :precision="2" :step="0.1" v-model="scope.row.accessoryPrice" v-if="scope.row.editing"></el-input-number>
                <span v-else>{{ scope.row.accessoryPrice }}</span>
              </template>
            </el-table-column> 
            <el-table-column :label="$t('label.Price_adjustment_status')" prop="priceAdjustStatus"  :formatter="formatStatus"/> 
            <el-table-column align="right">
            <template slot="header" slot-scope="scope">
                <el-input v-model="search" size="mini" :placeholder="$t('placeholder.Enter_keywords_to_search')"/>
            </template>
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.editing==false
              &&scope.row.syncFlg==0
              &&(scope.row.priceAdjustStatus==0||scope.row.priceAdjustStatus==3)
              &&isReplace==true" @click="scope.row.editing = true">{{$t('button.Edit')}}</el-button>
              
              <el-button size="mini" v-else-if="scope.row.editing==true
              &&scope.row.syncFlg==0
              &&(scope.row.priceAdjustStatus==0||scope.row.priceAdjustStatus==3)
              &&isReplace==true" @click="handleEdit(scope.$index, scope.row)">{{ $t('button.Save') }}</el-button>
              
              <el-button size="mini" v-if="scope.row.accessoryOrderId
              &&(scope.row.priceAdjustStatus==0||scope.row.priceAdjustStatus==3)
              &&scope.row.syncFlg==0" type="danger" @click="handleDelete(scope.$index, selectedAccessoryData,scope.row)">{{$t('common.delete')}}</el-button>
              
              <el-button size="mini" v-else-if="!scope.row.accessoryOrderId
              &&(scope.row.priceAdjustStatus==0||scope.row.priceAdjustStatus==3)
              &&scope.row.syncFlg==0" type="danger" @click="handleRemove(scope.$index, selectedAccessoryData)">{{$t('button.Remove')}}</el-button>
            </template>
            </el-table-column>
        </el-table>
      </div>
    </div>

     <!--待选择的配件弹出框-->
    <el-dialog
      width="60%"
      :title="$t('common.Choose_accessories')"
      :visible.sync="innerVisible"
      append-to-body>
       <!--待选择的配件列表-->
        <el-table ref="multipleTable" :data="candidateAccessoriesData.filter(data => !innerSearch 
            || data.name.toLowerCase().includes(innerSearch.toLowerCase())
            || data.dimension.toLowerCase().includes(innerSearch.toLowerCase())
            || data.material.toLowerCase().includes(innerSearch.toLowerCase())
            || data.thread.toLowerCase().includes(innerSearch.toLowerCase()))" 
            v-loading="loading"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" />
            <el-table-column property="name" :label="$t('label.Name')"/>
            <el-table-column property="dimension" :label="$t('label.Size')"/>
            <el-table-column property="material" :label="$t('label.Material')"/>
            <el-table-column property="thread" :label="$t('label.Screw_thread')"/>
            <el-table-column property="price" :label="$t('common.Unit_price')" :formatter="formatAmount"/>
            <el-table-column align="right">
            <template slot="header" slot-scope="scope">
                <el-input v-model="innerSearch" size="mini" :placeholder="$t('placeholder.Enter_keywords_to_search')"/>
            </template>
            </el-table-column>
        </el-table>
        <el-pagination
          @current-change="pagechange"
          :current-page="page.current"
          style="text-align: right;margin-top: 20px"
          background
          :total="page.total"
          :page-size="page.size"
          layout="prev, pager, next, jumper, ->, total"
       />
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">{{ $t('button.Cancel') }}</el-button>
          <el-button type="primary" @click="saveSelected()">{{ $t('button.Confirm') }}</el-button>
        </div>
    </el-dialog>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">{{ $t('button.Cancel') }}</el-button>
      <el-button type="primary" @click="confirmAndSyncOrderProductAccessory()">{{ $t('button.Confirm_and_save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { post, get } from '@/utils/request';
import { toDecimal2 } from '@/utils/numberUtils.js';

export default {
  data() {
    return {
      isReplace:false,
      isLoading: false,
      openSelectAccessoryLoading: false,
      loading: true,
      dialogFormVisible: false,
      innerVisible: false,
      orderId: '',
      orderNo: '',
      storeId: '',
      batchNumber: '',
      spuId: '',
      spuName: '',
      skuCount: 0,
      companyName: '',
      confirmStatus:0,
      selectedAccessoryData: [],
      candidateAccessoriesData: [],
      search: '',
      innerSearch: '',
      page: {
        total: 1,
        size: 10,
        current: 1,
      },
       multipleSelection: []
    };
  },
  methods: {
    // 初始化配件列表
    initAccessoryList(){
       if (this.orderId != null&&this.batchNumber != null) {
        this.isLoading = true;
         get('api/orderAccessories/getAccessoryList?orderId=' + this.orderId+'&batchNumber='+this.batchNumber)
         .then((res) => {
              if(res.data.data){
                // 循环处理数据，拼上编辑标识
                res.data.data.forEach(item=>{
                    item.editing=false
                })
                this.selectedAccessoryData=res.data.data
              }
          })
      }
    },
    // 打开选择配件框
    openSelectAccessory(){
      this.openSelectAccessoryLoading=true;
      // 请求加载待选配件列表
       get('api/accessories/getCandidateAccessorieslist?pageNum=1&pageSize=10').then((res) => {
          if (res.data.data) {
            this.candidateAccessoriesData=res.data.data.list
            this.page.total = res.data.data.total;
          }
        }).finally(() => {
          this.loading=false;
          this.openSelectAccessoryLoading=false;
          this.innerVisible=true;
        })
    },
    // 待选配件列表分页
    pagechange(p) {
       this.loading=true;
       this.page.current = p;
        get('api/accessories/getCandidateAccessorieslist?pageNum=' + p+'&pageSize=10').then((res) => {
          if (res.data.data) {
            this.candidateAccessoriesData=res.data.data.list
            this.page.total = res.data.data.total;
          }
        }).finally(() => {
          this.loading=false;
        })
    },
    // 勾选配件时存入集合中
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    // 保存已选的配件信息
    saveSelected(){
      // 组装数据
      if (this.multipleSelection!=null) {
        this.multipleSelection.forEach(item=>{
          this.selectedAccessoryData.push({
                    orderId:this.orderId,
                    orderNo:this.orderNo,
                    storeId: this.storeId,
                    batchNumber: this.batchNumber,
                    spuId: this.spuId,
                    spuName: this.spuName,
                    accessoryId: item.id,
                    accessoryAttributes: item.attributes,
                    accessoryName: item.name,
                    dimension: item.dimension,
                    material: item.material,
                    thread: item.thread,
                    accessoryOldPrice:toDecimal2(item.price),
                    accessoryPrice: toDecimal2(item.price),
                    accessoryCount: this.skuCount,
                    accessoryTotalPrice: item.price*this.skuCount,
                    dimension: item.dimension,
                    editing: false,
                    priceAdjustStatus:'0',
                    syncFlg:0,
                    opt:'ADD'
                  })
        })
      }
      this.innerVisible = false;
    },
    // 编辑
    handleEdit(index, row) {
      if(!row.accessoryPrice){
        row.accessoryPrice=0.00
      }else{
        row.accessoryPrice=toDecimal2(row.accessoryPrice)
      }
      row.editing = false; // 关闭编辑状态
    },
    // 移除
    handleRemove(index, rows) {
      rows.splice(index, 1);
    },
    // 删除
    handleDelete(index, rows,row) {
      this.$confirm(this.$t('confirm.Do_you_want_to_delete_this_accessory_information'), this.$t('common.Confirmation'), {
        confirmButtonText: this.$t('button.Confirm'),
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning',
      }).then(() => {
        get('api/orderAccessories/deleteOrderAccessoriesById?accessoryOrderId=' + row.accessoryOrderId).then(
          (res) => {
             rows.splice(index, 1);
            this.$message.success({
              message: this.$t('message.Successfully_deleted'),
            });
          }
        );
      });
    },
    // 确认并保存订单产品配件列表信息
    confirmAndSyncOrderProductAccessory(){

      let orderAccessoriesVo = {
        orderId:this.orderId,
        orderNo:this.orderNo,
        storeId: this.storeId,
        batchNumber: this.batchNumber,
        spuId: this.spuId,
        spuName: this.spuName,
        orderAccessoriesList:this.selectedAccessoryData
      };
     
     // 保存订单配件列表信息
      post('api/orderAccessories/confirmAndSaveOrderAccessories', orderAccessoriesVo).then(res=>{
        if(res.data.data){
          this.$message.success({
            message: this.$t('message.Price_adjustment_has_been_applied_for'),
          });
          // 发送配件订单调价审批消息
          // post('api/wxMsgPush/sendAdjustAccessoriesApplyWxMsg?orderId='+this.orderId+'&spuName='+this.spuName).then((res) => {
          // });
        }else{
          this.$message.success({
            message: this.$t('message.Successful_operation'),
          });          
        }
      }).catch(err=>
        console.log(err)
      ).finally(() => {
        this.dialogFormVisible=false;
      })
    },
    // 取消
    cancel() {
      this.resetAddForm();
    },
    // 刷新
    resetAddForm() {
      this.selectedAccessoryData=[];
      this.dialogFormVisible = false;
    },
    formatAmount(row, column, cellValue, index) {
      if (!cellValue) return '0.00';
      // 使用 toFixed 方法将数字格式化为小数，保留两位小数
      return cellValue.toFixed(2);
    },
    formatStatus(row, column, cellValue, index){
      if(cellValue==="0"){
        return this.$t('label.Not_applied');
      }else if (cellValue==="1") {
         return this.$t('label.In_approval');
      }else if (cellValue==="2") {
         return this.$t('label.Approved');
      }else if (cellValue==="3") {
         return this.$t('label.Approval_rejected');
      }else{
         return "——";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.transfer-footer {
    margin-left: 20px;
    padding: 6px 5px;
  }
.tishi {
  width: 90%;
  text-align: center;
  margin-top: 150px;
  font-size: 24px;
  color: rgb(139, 135, 135);
}
.right {
  width: 1006px;
  padding-top: 34px;
  padding-left: 27px;
  background: #fff;
  .spen {
    font-size: 26px;
    font-weight: 600;
    color: #616161;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .daohang {
      font-size: 15px;
      color: #272727;
      margin-right: 25px;
      height: 30px;

      .ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        width: 400px;
        li {
          list-style: none;
          cursor: pointer;
          &.router-link-exact-active.router-link-active {
            color: #3661fe;
          }
        }
      }
    }
    .search {
      margin-right: 150px;
      display: flex;
      input {
        border: 0;
        outline: none;
        border: 1px solid #a7a7a7;
        height: 37px;
        padding-left: 10px;
      }
      .fangdajing {
        width: 45px;
        height: 40px;
        border: 1px solid #a7a7a7;
        border-left: none;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .fenye {
    margin-top: 50px;
    margin-bottom: 20px;
  }
  .top {
    width: 100%;
    height: 42px;
    line-height: 42px;
    background: #f5f5f5;
    display: flex;
    margin-top: 30px;
    .biaoti {
      font-size: 16px;
      color: #888;
      margin-left: 20px;
      .danhao {
        color: #666;
        font-weight: 800;
      }
      img {
        width: 23px;
        height: 23px;
        margin-left: 10px;
      }
    }
    .mar {
      margin-left: 40px;
    }
    .kefu {
      display: flex;
      align-items: center;
    }
  }
  .bottom {
    width: 100%;
    height: 137px;

    display: flex;
    .pic {
      width: 180px;
      height: 136px;
      border-bottom: 1px solid #f5f5f5;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title1 {
      height: 100%;
      border-right: 1px solid #eaeaea;
      border-bottom: 1px solid #f5f5f5;
      .title {
        width: 240px;
        padding-top: 34px;
        display: flex;
        .miaoshu {
          color: #333;
          width: 190px;
          height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .shuliang {
          margin-left: 25px;
        }
      }
      .xiangsi {
        font-size: 14px;
        color: #9a9a9a;
        margin-top: 10px;
      }
    }
    .tousu {
      width: 102px;
      border-right: 1px solid #eaeaea;
      text-align: center;
      padding-top: 34px;
      font-size: 14px;
      color: #333;
    }
    .beidaigouren {
      width: 158px;
      border-right: 1px solid #eaeaea;
      padding-top: 34px;
      padding-left: 25px;
    }
    .price {
      width: 158px;
      border-right: 1px solid #eaeaea;
      padding-top: 34px;
      padding-left: 25px;
      .jiage {
        font-size: 14px;
        color: #333;
      }
      .yunfei {
        color: #a0a0a0;
        font-size: 14px;
      }
      .fangshi {
        color: #a0a0a0;
        font-size: 14px;
      }
    }
    .zhuangtai {
      width: 130px;
      padding-top: 34px;
      border-right: 1px solid #eaeaea;
      text-align: center;
      color: #333;
      .xiangqing {
        margin-top: 5px;
        cursor: pointer;
      }
      .wuliu {
        color: #dc7413;
        margin-top: 5px;
      }
      .quxiao {
        color: #a0a0a0;
        margin-top: 5px;
      }
    }
    .pay {
      width: 136px;
      padding-top: 34px;
      border-right: 1px solid #eaeaea;
      font-size: 12px;
      color: #333;
      text-align: center;
      .liji {
        color: #fff;
        background: #1850ff;
        padding: 5px 10px;
        width: 85px;
        border-radius: 5px;
        margin: 0 auto;
        cursor: pointer;
      }
      .liji1 {
        color: #fff;
        background: #ff902a;
        padding: 5px 10px;
        width: 85px;
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 10px;
        cursor: pointer;
      }
      .daifu {
        cursor: pointer;
        margin-top: 5px;
      }
      .quxiao {
        cursor: pointer;
        margin-top: 5px;
      }
    }
  }
}
.tree1 {
  /*width: 100%;*/
  background: #f5f5f5;
  .tree {
    /*width: 1236px;*/
    margin: 0 auto;
    background: #fff;
    padding: 50px 40px 70px 35px;
    .tree-title {
      display: flex;
      align-items: center;
      padding: 10px 0 10px 10px;
      background: #f3f3f3;
      border: 1px solid #e9e9e9;
      .shangpin {
        width: 260px;
        margin-left: 140px;
      }
      .danjia {
        width: 167px;
        text-align: center;
      }
      .shuliang {
        width: 130px;
        text-align: center;
      }
      .xiaoji {
        text-align: center;
        width: 170px;
      }
      .caozuo {
        text-align: center;
        flex: 1;
      }
    }
    .tree-merchant {
      margin: 10px 0px;
      .tree-merchant-name {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        border-bottom: 2px solid #999;
      }
      .tree-goods {
        font-size: 14px;
        color: #4c4c4c;
        display: flex;
        padding-top: 10px;
        height: 180px;
        border: 1px solid #e4e4e4;
        padding-left: 10px;
        .goods-pic {
          width: 130px;
          height: 126px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .goods-jieshao {
          width: 240px;
          height: 180px;
          padding: 20px 10px 0 10px;
          margin-left: 10px;
          overflow: hidden;
        }
        .goods-xinghao {
          width: 180px;
          padding-top: 15px;
          margin-left: 20px;
          .goods-xinghao-list {
            display: flex;
            margin-top: 5px;
            color: #9c9c9c;
          }
        }
        .goods-danjia1 {
          width: 160px;
          padding-top: 20px;
          text-align: center;
        }
        .goods-shuliang1 {
          width: 106px;
          padding-top: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 20px;
          .youhuo {
            color: #a8a8a8;
            margin-top: 10px;
          }
          .wuhuo {
            color: #e83f38;
          }
          &-num {
            // display: flex;
            // align-items: center;
            margin-left: 5px;
            .L {
              cursor: pointer;
            }
            .R {
              cursor: pointer;
              margin-left: 10px;
            }
            .C {
              /*width: 50px;*/
              margin-left: 10px;
              input {
                width: 40px;
                /*border: none;*/
                /*outline: none;*/
                text-align: center;
                padding: 0 10px;
                margin-bottom: 10px;
                background: #fff;
              }
            }
          }
        }
        .goods-tiaojia {
          width: 125px;
          padding-top: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 10px;
          .youhuo {
            color: #a8a8a8;
            margin-top: 10px;
          }
          .wuhuo {
            color: #e83f38;
          }
          &-num {
            // display: flex;
            // align-items: center;
            margin-left: 5px;
            .L {
              cursor: pointer;
            }
            .R {
              cursor: pointer;
              margin-left: 10px;
            }
            .C {
              /*width: 50px;*/
              margin-left: 10px;
              margin-right: 10px;
              input {
                width: 40px;
                /*border: none;*/
                /*outline: none;*/
                text-align: center;
                padding: 0 10px;
                margin-bottom: 10px;
                background: #fff;
              }
            }
          }
        }

        .goods-xiaoji1 {
          width: 195px;
          padding-top: 20px;
          text-align: center;
        }
        .goods-caozuo1 {
          width: 120px;
          padding-top: 20px;
          text-align: center;
          color: #343434;
          .shan {
            cursor: pointer;
          }
          .yiru {
            cursor: pointer;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .jiesuan {
    width: 100%;
    height: 100px;
    background: #fff;
    .tree-bottom_C {
      /*width: 1150px;*/
      height: 80px;
      margin: 10px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .jiesuan_L {
        display: flex;
        align-items: center;
        .quanxuan {
          padding-top: 5px;
          color: #343434;
        }
        .shanchu {
          margin-left: 20px;
          color: #484848;
          padding-top: 5px;
          cursor: pointer;
        }
        .shanchu:hover {
          color: red;
          border-bottom: 1px solid red;
        }
        .yiru {
          margin-left: 20px;
          color: #484848;
          padding-top: 5px;
          cursor: pointer;
        }
        .yiru:hover {
          border-bottom: 1px solid #484848;
        }
      }
      .jiesuan_R {
        font-size: 14px;
        color: #989898;
        display: flex;
        align-items: center;
        .yixuanze {
          .spen {
            color: #1a50fb;
          }
        }
        .img {
          width: 15px;
          height: 9px;
          margin-left: 10px;
        }
        .zongjia {
          margin-left: 40px;
          .money {
            color: #1b50fe;
          }
        }
        .tijiao {
          width: 84px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background: #1850ff;
          color: #fff;
          border-radius: 5px;
          margin-left: 17px;
          cursor: pointer;
        }
      }
    }
  }
  input {
    appearance: none;
    outline: none;
    margin-top: 10px;
    padding: 0;
    margin-right: 10px;
  }
  input[type='checkbox'] {
    position: relative;
    width: 20px;
    height: 20px;
    background: #d5d5d5;
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    &:checked::after {
      content: '';
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      color: #333;
      text-align: center;
      line-height: 18px;
      background: url('https://static.98ep.com/img/BigCompany/a.png') no-repeat
        center;
    }
  }

  input[type='checkbox']:checked::after {
    content: '';
    background-color: #037df3;
    border-color: #037df3;
    background-color: #037df3;
  }
  input[type='checkbox']:checked::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 5px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    z-index: 1;
  }
  button {
    margin-top: 20px;
  }
}

.shuxing {
    margin-left: 10px;
    font-size: 12px;
    color: #9a9a9a;
    /* margin-top: 10px; */
    display: flex;
}
</style>
